import { render, staticRenderFns } from "./TimeType.vue?vue&type=template&id=2a5398cf&"
import script from "./TimeType.vue?vue&type=script&lang=js&"
export * from "./TimeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports